export default __webpack_public_path__ + "static/media/crossplane.03152bc3.svg";